export default __webpack_public_path__ + "static/media/char_head_prem_011.825bb6d6.png";